import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, Spinner } from 'react-bootstrap';
import './testresult.css';
import { fetchStudentTestresult } from '../../actions/testActions';

function TestResults() {
  const studenttestresult = useSelector(state => state.tests.studenttestresult);
  const loading = useSelector(state => state.tests.studentresultloding);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!studenttestresult.length) {
      dispatch(fetchStudentTestresult());
    }
  }, []);


  // Handle loading state
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh', color: '#0096c7' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  // Calculate pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = studenttestresult.slice(indexOfFirstItem, indexOfLastItem);
  const totalItems = studenttestresult.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  // Status badge styling
  const getStatusBadge = (status) => {
    const style = {
      padding: '4px 8px',
      borderRadius: '12px',
      fontWeight: 'bold',
      fontSize: '0.8rem',
      textTransform: 'uppercase'
    };

    if (status === 'Pass') {
      return <span style={{ ...style, backgroundColor: '#d4edda', color: '#155724' }}>{status}</span>;
    } else {
      return <span style={{ ...style, backgroundColor: '#f8d7da', color: '#721c24' }}>{status}</span>;
    }
  };

  return (
    <div className="test-results-container">
      <div className="table-wrapper">
        <div className="table-responsive">
          <table className="table table-striped table-hover">
            <thead  style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                <th className="table-header">#</th>
                <th className="table-header">Test Name</th>
                <th className="table-header">Correct Answers</th>
                <th className="table-header">Total Questions</th>
                <th className="table-header">Obtained Marks</th>
                <th className="table-header">Total Marks</th>
                <th className="table-header">Status</th>
              </tr>
            </thead>

            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((result, index) => (
                  <tr key={index}>
                    <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                    <td>{result.testName}</td>
                    <td>{result.correctAnswers}</td>
                    <td>{result.totalQuestions}</td>
                    <td>{result.obtainedMarks}</td>
                    <td>{result.totalMarks}</td>
                    <td>{getStatusBadge(result.passStatus)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4">No test results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          <div className="hint-text">
            Showing <b>{currentItems.length}</b> out of <b>{totalItems}</b> entries
          </div>

          {totalPages > 1 && (
            <Pagination className="pagination-container">
              <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              />
              {[...Array(totalPages)].map((_, index) => (
                <Pagination.Item
                  key={index}
                  active={index + 1 === currentPage}
                  onClick={() => setCurrentPage(index + 1)}
                >
                  {index + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              />
            </Pagination>
          )}
        </div>
      </div>
    </div>
  );
}

export default TestResults;